import { render, staticRenderFns } from "./ReservationStatsCard.vue?vue&type=template&id=5c2bb766&scoped=true&"
import script from "./ReservationStatsCard.vue?vue&type=script&lang=js&"
export * from "./ReservationStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./ReservationStatsCard.vue?vue&type=style&index=0&id=5c2bb766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2bb766",
  null
  
)

export default component.exports